/** Multi-instance caps: white-label custom domains, webhook endpoints, ad accounts — English (structure pinned to fr). */
import type { MiIntegrationsKeys } from './fr';

const miIntegrationsEn: MiIntegrationsKeys = {
  customDomains: {
    title: 'Custom domains (white label)',
    intro:
      'Serve your white-label workspace on your own domains. The primary domain is used by default; each domain must prove you control it with a DNS TXT record.',
    addLabel: 'Add a domain',
    placeholder: 'app.your-domain.com',
    makePrimary: 'Make it the primary domain',
    add: 'Add',
    adding: 'Adding…',
    empty: 'No custom domain yet.',
    loading: 'Loading domains…',
    primary: 'Primary',
    setPrimary: 'Set as primary',
    verify: 'Verify DNS',
    verifying: 'Verifying…',
    delete: 'Delete',
    confirmDelete: 'Confirm delete',
    statusPending: 'Awaiting verification',
    statusVerified: 'Verified',
    statusFailed: 'Record not found',
    instructions: 'Add this TXT record at your DNS provider, on {{host}} or on {{altHost}}:',
    recordValue: 'TXT value',
    copy: 'Copy',
    copied: 'Copied',
    lastChecked: 'Last checked: {{when}}',
    added: 'Domain added. Publish the TXT record, then run the verification.',
    verifiedOk: 'Domain verified.',
    verifyNotFound: 'TXT record not found yet. DNS propagation can take up to an hour.',
    verifyLookupFailed: 'The DNS service did not answer, try again in a moment.',
    deleted: 'Domain deleted.',
    primarySet: 'Primary domain updated.',
    errorLoad: 'Could not load the custom domains.',
    errorGeneric: 'The operation failed. Please try again.',
    invalidDomain: 'Invalid domain name (example: app.your-domain.com).',
    duplicate: 'This domain is already one of your domains.',
    overLimitReadOnly:
      'This domain is above your plan limit and is read-only. Delete another domain or upgrade your plan.',
    readOnlyRole: 'A write role is required to manage domains.',
  },
  webhooks: {
    overLimitReadOnly: 'This endpoint is above your plan limit and is read-only (it can still be deleted).',
  },
  ads: {
    overLimitReadOnly: 'This ad account is above your plan limit and is read-only (it can still be unlinked).',
  },
};

export default miIntegrationsEn;
